import { Modules } from '~/data/modules';
import { Roles } from '~/data/user';
import { hasOneOfRoles } from '~/services/Permissions';

export const checkModuleActiveBasedOnConfig =
  (modules: string[], roles: string[]) => (module: string) => {
    const hasElevatedAccess = hasOneOfRoles(roles, [
      Roles.HR_ADMIN,
      Roles.HR_ADMIN_LIMITED,
      Roles.HR_STAFF,
      Roles.MANAGER,
    ]);

    const hasRegularAccess = hasOneOfRoles(roles, [
      Roles.HR_ADMIN,
      Roles.HR_ADMIN_LIMITED,
      Roles.HR_STAFF,
      Roles.MANAGER,
      Roles.ALT_MANAGER,
    ]);

    switch (module) {
      case Modules.PLANNING: {
        return (
          modules.includes(module) && (hasRegularAccess || hasElevatedAccess)
        );
      }
      case Modules.RECRUITING_MINI:
      case Modules.RECRUITING_FULL: {
        const hasRegularRecAccess =
          hasRegularAccess || roles.includes(Roles.DEPUTY_MANAGER);
        const hasRecElevatedAccess =
          hasElevatedAccess ||
          roles.some((r) => r === Roles.HR_DEV || r === Roles.ALT_MANAGER);

        return (
          (modules.includes(module) && hasRegularRecAccess) ||
          hasRecElevatedAccess
        );
      }
      default: {
        return modules.includes(module);
      }
    }
  };
